/* unplugin-vue-components disabled */import script from "./list.vue?vue&type=script&lang=jsx"
export * from "./list.vue?vue&type=script&lang=jsx"

import "./list.vue?vue&type=style&index=0&id=10b1ca7a&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10b1ca7a"]])

export default __exports__